import React from "react";
import { Typography } from "@mui/material";
//import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
function NoListData({ message }) {
    //const { t } = useTranslation("common");
    return (
        <Typography display="flex" flexDirection="row" justifyContent="center" alignItems="center">
            <h2>{message || "No Data Found"}</h2>
            {/* <h2>{"No recent transactions found"}</h2> */}
        </Typography>
    )
}
// Set default props for 'message'
NoListData.defaultProps = {
    message: "No Data Found",
};
// Prop types validation
NoListData.propTypes = {
    message: PropTypes.string,
};

export default NoListData;